/** LOCATIONS.JS **/

/* Initialize */
var page_settings = {
    'video1_play' : false,
    'video2_play' : false
}
var video1 = document.getElementById('video1');
var video2 = document.getElementById('video2');

/* Control Flow */
window.onload = (event) => {
    videoListener();

    if(location.hash == "#mt_pleasant"){
        window.scroll({
            top: $('[data-value="mt_pleasant"]').position().top - $('#header').outerHeight(),
            left: 0,
            behavior: 'smooth',
        })
        playVideo1();
    }
    setTimeout(function() { 
        if(location.hash == "#north_charleston"){
            window.scroll({
                top: $('[data-value="north_charleston"]').position().top - $('#header').outerHeight(),
                left: 0,
                behavior: 'smooth',
            })
            playVideo2();
        }

     }, 500);
};


/* Listeners */
function videoListener() {    
        $(window).scroll(function() {
            var scrollTop = $(window).scrollTop();
            var scrollBottom = scrollTop + $(window).height();
    
            // If scroll to video1
            if(scrollBottom  > ($(video1).position().top + $(video1).outerHeight() - 50)) {
                if (page_settings.video1_play == false){
                    playVideo1();
                }
            }

            // If scroll to video2
            if(scrollBottom  > ($(video2).position().top + $(video2).outerHeight() - 50)) {
                if (page_settings.video2_play == false){
                    playVideo2();
                }
            }
        });

}
function playVideo1() {
    page_settings.video1_play = true;
    video1.play();
}
function playVideo2() {
    page_settings.video2_play = true;
    video2.play();
}


